namespace SP {
    export interface StockHall {
        id: string;
        stockId: string;
        name: string;
        gridX: number;
        gridY: number;
        itemSize: number;
    }
}